import axios from "axios"

export const axiosInstance = axios.create({
    baseURL : "https://natura.co.in"
    // baseURL : "http://localhost:7000"
})